import { Navigate, useLocation } from 'react-router-dom';

import PageLoader from '../component/loader/PageLoader';

import { useAuth } from '../hooks/useAuth';

import AppNavigationProvider from '../provider/AppNavigationProvider';

const AdminRoute = ({ children }) => {
  const { user, isAdmin, pageLoading } = useAuth();
  const location = useLocation();

  return (
    <AppNavigationProvider>
      <PageLoader loading={pageLoading}>
        {user ? (
          <>{isAdmin ? <>{children}</> : <Navigate to="/" state={{ from: location }} replace />}</>
        ) : (
          <Navigate to="/login" state={{ from: location }} replace />
        )}
      </PageLoader>
    </AppNavigationProvider>
  );
};

export default AdminRoute;
